import { FC } from 'react';
import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import PageSection from 'components/PageSection';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import Spacing from 'components/Spacing';
import { Typography } from '@mui/material';
import { UnrealisedAssetFXGainOrLossTypeLabels } from 'further-ui/labels';
import { numberToCurrencyString } from 'further-ui/utils';
import FieldRow from 'components/FormElements/FieldRow';
import RecordView from 'components/RecordView';

const AssetsHistoryDetail: FC = () => {
  const { recordId } = useParams<{ recordId: string }>();
  const { vehicle } = useLayoutContext();

  const [record] = api.unrealisedAssetFxGainOrLoss.getById.useSuspenseQuery({
    vehicleId: vehicle?._id ?? '',
    recordId,
  });

  if (!vehicle) {
    return null;
  }

  if (!record) {
    return (
      <PageContainer>
        <PageContent>
          <PageSection>
            <p>Record not found</p>
          </PageSection>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageContent>
        <Spacing>
          <PageSection
            title="Unrealised Asset FX Gain/Loss Details"
            withSpacing
          >
            <RecordView>
              <FieldRow title="Date">
                <Typography variant="body2">
                  {record.ledgerDate.toLabel()}
                </Typography>
              </FieldRow>
              <FieldRow title="Asset">
                <Typography variant="body2">
                  {record.assetName ?? '-'}
                </Typography>
              </FieldRow>
              <FieldRow title="Holding Class">
                <Typography variant="body2">
                  {record.holdingClassName ?? '-'}
                </Typography>
              </FieldRow>
              <FieldRow title="Type">
                <Typography variant="body2">
                  {UnrealisedAssetFXGainOrLossTypeLabels[record.gainOrLossType]}
                </Typography>
              </FieldRow>
              <FieldRow title="Amount (LCY)">
                <Typography variant="body2">
                  {numberToCurrencyString(record.amountLcy, {
                    currency: vehicle.baseCurrency,
                    negativeInBrackets: true,
                  })}
                </Typography>
              </FieldRow>
              <FieldRow title="Currency">
                <Typography variant="body2">{record.currencyCode}</Typography>
              </FieldRow>
            </RecordView>
          </PageSection>
        </Spacing>
      </PageContent>
    </PageContainer>
  );
};

export default AssetsHistoryDetail;
